import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import "./LanguageSwitcher.css";

export const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const languages = [
        { code: 'en', nativeName: 'English' },
        { code: 'ro', nativeName: 'Română' }
    ];

    const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

    const toggleMenu = () => setIsOpen(!isOpen);

    const changeLanguage = (langCode) => {
        i18n.changeLanguage(langCode);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div className="language-switcher" ref={menuRef}>
            <button 
                className="language-button" 
                onClick={toggleMenu}
                aria-label="Change language"
            >
                <FontAwesomeIcon icon={faGlobe} />
                <span className="current-language">{currentLanguage.code.toUpperCase()}</span>
            </button>
            {isOpen && (
                <div className="language-menu">
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            className={`language-option ${lang.code === i18n.language ? 'active' : ''}`}
                            onClick={() => changeLanguage(lang.code)}
                        >
                            {lang.nativeName}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
